var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.86 20.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.48,0h.67c1.12,0,2.02.91,2.02,2.03v3.95c-.63-.27-1.31-.46-2.02-.53v-3.43H2.02v12.2h11.02c.23.74.59,1.43,1.05,2.03H2.02c-1.12,0-2.02-.91-2.02-2.03V2.03C0,.91.91,0,2.02,0h17.46ZM22.85,16.44v2.38c0,.84-.68,1.52-1.52,1.52h-3.71c-.84,0-1.52-.68-1.52-1.52v-2.38c-1.23-.99-2.02-2.52-2.02-4.24,0-2.01,1.09-3.76,2.7-4.7.31-.18.67.06.67.42v3.6c0,1.13.91,2.03,2.02,2.03s2.02-.91,2.02-2.03v-3.6c0-.36.37-.61.67-.42,1.61.94,2.7,2.69,2.7,4.7,0,1.71-.78,3.24-2.02,4.24h.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkOrder);
export default __webpack_public_path__ + "static/media/work_order.16bed6e42cb76ac59daa3b64c374c5e0.svg";
export { ForwardRef as ReactComponent };